/**
 *
 * ClassListItem
 *
 */

import React, { memo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

// antd component
import { List } from 'antd';

function ClassListItem({
  element,
  searchString,
  // formats
  timeFormat,
  dateFormat,
  // func
  customHighlighter,
  // default props
  className,
  ...rest
}) {
  const childClassNames = classNames('class-list-meta', className);

  let incumbent = element?.incumbent?.description
      ? `${element?.incumbent?.description?.lastname} ${element?.incumbent?.description?.firstname}`
      : '';
  const length = `${element?.students?.length} étudiants`;
  
  return element && (
    <List.Item.Meta
      className={childClassNames}
      title={customHighlighter(element?.title, searchString)}
      description={
        <>
          <span className="students-amount">
            {customHighlighter(length, searchString)}
          </span>
          {customHighlighter(incumbent, searchString)}
        </>
      }
    />
  );

};

ClassListItem.defaultProps = {
  dateFormat: 'DD.MM.YYYY',
  timeFormat: 'HH:mm',
};
ClassListItem.propTypes = {
  element: PropTypes.oneOfType([
    PropTypes.object.isRequired,
    PropTypes.bool.isRequired,
  ]),
  searchString: PropTypes.string,
  customHighlighter: PropTypes.func,
};

export default memo(ClassListItem);